import type { ZeroHashPermission } from "../../tastyworks"
import type HttpClient from "../../tastyworks/http"
import { updateSingleResponse } from "../../tastyworks/response"
import {
  ZERO_HASH_CLIENT_AUTH_TOKEN_DESER,
  ZeroHashClientAuthToken,
} from "../../tastyworks/zero-hash"

interface AccessTokenOptions {
  permission: ZeroHashPermission
  withdrawalAmount?: string
  digitalAssetCustomerAddressId?: number
}

export class ZeroHashService {
  private readonly client: HttpClient

  constructor(accountNumberClient: HttpClient) {
    this.client = accountNumberClient.nested("zero-hash")
  }

  readonly createAccessToken = async (
    accountNumber: string,
    {
      permission,
      withdrawalAmount,
      digitalAssetCustomerAddressId,
    }: AccessTokenOptions
  ) => {
    const helper = await this.client.postJson(
      "/access-token",
      {
        permission,
        "withdrawal-amount": withdrawalAmount,
        "digital-asset-customer-address-id": digitalAssetCustomerAddressId,
      },
      { accountNumber }
    )

    return updateSingleResponse(
      helper,
      new ZeroHashClientAuthToken(),
      ZERO_HASH_CLIENT_AUTH_TOKEN_DESER.update
    )
  }
}
